<template>
  <div class="page">
    <div class="nav-header" style="background:#242a3c;height:60px;width:103%;margin-left:-25px;margin-top:-25px">
      <a>
        <!--<img src="/static/imgs/logo_white.png" alt="ydm_logo">-->
        <!-- <img src="/static/imgs/fengyan/logoTop.png" style="height: 100%;opacity: 0.3" alt=""> -->
        <img src="/static/imgs/fengyan/logomini.png" alt="" style="height: 60px">
        <span style="color: #fff; font-size:32px;font-weight:bold;position: relative;top: -15px;left: 10px;">实时监控</span>
        <!--<img src="/static/imgs/001-1_meitu_2.png" style="height: 50px" alt="">-->
      </a>
      <!-- <span style="color: #fff">实时监控</span> -->
    </div>
    <br/>
          <!-- 头部 -->
      <div class="index-header">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-card shadow="never">
              <div style="float:left">
                <span style="font-size:50px;font-weight:bold">{{todayCaseCount}}</span>
                <p class="text lighter">新导案件数</p>
              </div>
              <div style="position: relative;right: -30%;top:55px;">
                <p v-if="this.beforeCaseRate.toString().substring(0,1) === '-'">
                 <i class="el-icon-caret-bottom" style="font-size:20px">{{beforeCaseRate.toString().substring(1,10)}}% </i>
                </p>
                <p  v-else>
                 <i class="el-icon-caret-top" style="font-size:20px">{{beforeCaseRate}}% </i>
                </p>
                <p>相比7天前</p>
              </div>
              <br/>
              <br/>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div style="float:left">
                <p style="font-size:50px;font-weight:bold">{{collectingCount}}</p>
                <p class="text lighter">作业中案件数</p>
              </div>
              <div style="position: relative;right: -30%;top:55px;">
                <p class="text light" v-if="this.beforeCollectingRate.toString().substring(0,1) === '-'">
                  <i class="el-icon-caret-bottom" style="font-size:20px">{{beforeCollectingRate.toString().substring(1,10)}}% </i>
                </p>
                <p class="text light" v-else>
                  <i class="el-icon-caret-top" style="font-size:20px">{{beforeCollectingRate}}% </i>
                </p>
                <p>相比7天前</p>
              </div>
              <br/>
              <br/>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div style="float:left">
                <p style="font-size:50px;font-weight:bold">{{msgSendCount}}</p>
                <p class="text lighter">短信发送数</p>
              </div>
              <div style="position: relative;right: -30%;top:55px;">
                <p class="text light" v-if="this.beforeMsgSendRate.toString().substring(0,1) === '-'">
                  <i class="el-icon-caret-bottom" style="font-size:20px">{{beforeMsgSendRate.toString().substring(1,10)}}% </i>
                </p>
                <p class="text light" v-else>
                  <i class="el-icon-caret-top" style="font-size:20px">{{beforeMsgSendRate}}% </i>
                </p>
                <p>相比7天前</p>
              </div>
              <br/>
              <br/>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div style="float:left">
                <p style="font-size:50px;font-weight:bold">{{msgResponseRate}}%</p>
                <p class="text lighter">短信回复率</p>
              </div>
              <div style="position: relative;right: -30%;top:55px;">
                <p class="text light" v-if="this.beforeMsgResponseRate.toString().substring(0,1) === '-'">
                  <i class="el-icon-caret-bottom" style="font-size:20px">{{beforeMsgResponseRate.toString().substring(1,10)}}% </i>
                </p>
                <p class="text light" v-else>
                  <i class="el-icon-caret-top" style="font-size:20px">{{beforeMsgResponseRate}}% </i>
                </p>
                <p>相比7天前</p>
              </div>
              <br/>
              <br/>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="index-section m-t-24">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="panel">
              <div class="panel-header">
                <i class="el-icon-view">&nbsp;平台运行监控</i><br/><br/>
                <template>
                  <span v-if="msgAlarmClass && msgAlarmClass==='red'">
                   <el-tag type="danger" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">短信平台</el-tag><br/>
                  </span>
                  <span v-else-if="msgAlarmClass && msgAlarmClass==='yellow'">
                    <el-tag type="warning" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">短信平台</el-tag><br/>
                  </span>
                  <span v-else>
                    <el-tag type="success" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">短信平台</el-tag><br/>
                  </span>
                </template>
                <template>
                  <span v-if="voiceAlarmClass && voiceAlarmClass==='red'">
                   <el-tag type="danger" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">语音平台</el-tag><br/>
                  </span>
                  <span v-else-if="voiceAlarmClass && voiceAlarmClass==='yellow'">
                    <el-tag type="warning" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">语音平台</el-tag><br/>
                  </span>
                  <span v-else>
                    <el-tag type="success" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">语音平台</el-tag><br/>
                  </span>
                </template>
                <template>
                  <span v-if="interfaceOutAlarmClass && interfaceOutAlarmClass==='red'">
                   <el-tag type="danger" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">导入/更新接口</el-tag><br/>
                  </span>
                  <span v-else-if="interfaceOutAlarmClass && interfaceOutAlarmClass==='yellow'">
                    <el-tag type="warning" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">导入/更新接口</el-tag><br/>
                  </span>
                  <span v-else>
                    <el-tag type="success" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">导入/更新接口</el-tag><br/>
                  </span>
                </template>
                <template>
                  <span v-if="interfacePushAlarmClass && interfacePushAlarmClass==='red'">
                   <el-tag type="danger" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">推送接口</el-tag><br/>
                  </span>
                  <span v-else-if="interfacePushAlarmClass && interfacePushAlarmClass==='yellow'">
                    <el-tag type="warning" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">推送接口</el-tag><br/>
                  </span>
                  <span v-else>
                    <el-tag type="success" style="width: 100%;font-size:20px;display: flex;justify-content:center;align-items:Center;height:40px">推送接口</el-tag><br/>
                  </span>
                </template>
              </div>
            </div><br/><br/>
            <div class="panel">
              <div class="panel-header">
                <i class="el-icon-view">&nbsp;打标监控</i>
              </div>
               <div class="panel-content">
                <el-table
                  ref="singleTable"
                  :data="labelList"
                  border
                  size="small"
                  highlight-current-row
                  style="width: 100%;font-size: 15px">
                  <el-table-column
                    property="labelName"
                    label="标签">
                  </el-table-column>
                  <el-table-column
                    property="labelClockRateS"
                    label="浮动比">
                    <template slot-scope="scope">
                      <span v-if="scope.row.labelClass != null"><i class="el-icon-caret-top" style="color:red;">{{scope.row.labelClockRateS}}%</i></span>
                      <span v-else>{{scope.row.labelClockRateS}}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="panel">
              <div class="panel-header">
                <i class="el-icon-tickets">&nbsp;公司明细</i>
              </div>
              <div class="panel-content">
                <el-table
                  ref="singleTable"
                  :data="caseOfCompanyInfo"
                  border
                  size="small"
                  highlight-current-row
                  style="width: 100%;font-size: 15px">
                  <el-table-column
                    property="companyName"
                    label="公司名称"
                    width="210px">
                  </el-table-column>
                  <el-table-column
                    property="caseCount"
                    label="新导案件">
                  </el-table-column>
                  <el-table-column
                    property="collectingCountDel"
                    label="作业中案件">
                  </el-table-column>
                  <el-table-column
                    property="messageNumberCount"
                    label="件均发送短信数">
                    <template slot-scope="scope">
                      <span v-if="scope.row.messageNumberCount!=0 && scope.row.caseTimes!=0">{{(scope.row.messageNumberCount / scope.row.caseTimes).toFixed(2)}}</span>
                      <span v-else>{{scope.row.messageNumberCount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="msgSendFailRate"
                    label="短信失败率">
                    <template slot-scope="scope">
                      <span v-if="scope.row.msgSendFailRate>5" style="color:red;">{{scope.row.msgSendFailRate}}%</span>
                      <span v-else>{{scope.row.msgSendFailRate}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="voiceSendFailRate"
                    label="语音失败率">
                    <template slot-scope="scope">
                      <span v-if="scope.row.voiceSendFailRate>5" style="color:red;">{{scope.row.voiceSendFailRate}}%</span>
                      <span v-else>{{scope.row.voiceSendFailRate}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="caseTouchOfRate"
                    label="案件触达率">
                    <template slot-scope="scope">
                      <span v-if="scope.row.caseTouchOfRate<90" style="color:red;">{{scope.row.caseTouchOfRate}}%</span>
                      <span v-else>{{scope.row.caseTouchOfRate}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="hfcaseRateS"
                    label="案件回复率">
                    <template slot-scope="scope">
                      <span>{{scope.row.hfcaseRateS}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="willingPayRateS"
                    label="有还款意向">
                    <template slot-scope="scope">
                      <span>{{scope.row.willingPayRateS}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="paidRateS"
                    label="已还款">
                    <template slot-scope="scope">
                      <span>{{scope.row.paidRateS}}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    property="confirmedPaymentRateS"
                    label="核实还款">
                    <template slot-scope="scope">
                      <span>{{scope.row.confirmedPaymentRateS}}%</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="text center margin15-tb">
                  <el-pagination
                    background
                    layout="prev, pager, next, sizes, total"
                    :page-sizes="[10, 20, 50]"
                    :total="caseCompanyInfo.totalRecords"
                    :page-size="caseCompanyInfo.limit"
                    :current-page="caseCompanyInfo.page"
                    @current-change="currentChange"
                    @size-change="sizeChange">
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <br/>
      <br/>
      <br/>
      <div class="bg-content padding15 m-b-24" style="position: fixed; bottom: 0;background-color:transparent;margin-left:80%">
        最近更新时间:{{this.time}}
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      todayCaseCount: 0,
      beforeCaseRate: 0,
      collectingCount: 0,
      beforeCollectingRate: 0,
      msgSendCount: 0,
      beforeMsgSendRate: -10,
      msgResponseRate: 0,
      beforeMsgResponseRate: -50,
      labelList: [],
      caseOfCompanyInfo: [],
      time: null,
      msgAlarmClass: null,
      voiceAlarmClass: null,
      interfaceOutAlarmClass: null,
      interfacePushAlarmClass: null,
      caseCompanyInfo: {
        totalRecords: 0,
        limit: 10,
        page: 1
      },
      contactInterval: null,
      pages: 1
    };
  },
  watch: {
    pages() {
      this.timing();
    }
  },
  mounted() {
    this.getMonitorCaseData();
    this.getMonitorLabelData();
    this.alarmPlatform();
    // 定时刷新
    this.contactInterval = setInterval(() => {
      this.getMonitorCaseData();
      this.getMonitorLabelData();
      this.alarmPlatform();
    }, 60000);
  },
  beforeDestroy() {
    if (this.contactInterval) {
      console.warn('清除interval');
      clearInterval(this.contactInterval);
      clearInterval(this.contactIntervalTiming);
    }
  },
  methods: {
    timing() {
      const pages = this.pages;
      if (pages > 1) {
        this.contactIntervalTiming = setInterval(() => {
          for (let index = 1; index <= pages; index++) {
            setTimeout(() => {
              this.caseCompanyInfo.page = index;
              this.getMonitorCaseData();
            }, index * 10000);
          }
        }, 20000);
      }
    },
    currentChange(page) {
      this.caseCompanyInfo.page = page;
      this.getMonitorCaseData();
    },
    // 显示条数
    sizeChange(num) {
      this.caseCompanyInfo.limit = num;
      this.getMonitorCaseData();
    },
    // 列表数据
    getMonitorCaseData() {
      const search = this.caseCompanyInfo;
      this.$ajax({
        url: '/alarm/getMonitorCaseData',
        data: search
      }).then((res) => {
        this.todayCaseCount = res.data.caseCount;
        this.beforeCaseRate = res.data.beforeCaseRateS;

        this.collectingCount = res.data.collectingCount;
        this.beforeCollectingRate = res.data.beforeCollectingRateS;

        this.msgSendCount = res.data.msgSendCount;
        this.beforeMsgSendRate = res.data.beforeMsgSendRateS;

        this.msgResponseRate = res.data.msgResponseRate;
        this.beforeMsgResponseRate = res.data.beforeMsgResponseRateS;

        this.time = res.data.lastUpdateTime;

        this.caseCompanyInfo.totalRecords = res.data.dtoPageBean.totalRecords;
        this.caseOfCompanyInfo = res.data.dtoPageBean.list;

        this.pages = Math.ceil(this.caseCompanyInfo.totalRecords / this.caseCompanyInfo.limit);
      });
    },
    // 打标监控数据
    getMonitorLabelData() {
      this.$ajax({
        url: '/alarm/getMonitorLabelData'
      }).then((res) => {
        this.labelList = res.data.labelOfDayList;
      });
    },
    // 平台运行监控数据
    alarmPlatform() {
      this.$ajax({
        url: '/alarm/alarmPlatform'
      }).then((res) => {
        if (res.data.msgAlarmClass) {
          this.msgAlarmClass = res.data.msgAlarmClass;
        }
        if (res.data.voiceAlarmClass) {
          this.voiceAlarmClass = res.data.voiceAlarmClass;
        }
        if (res.data.interfaceOutAlarmClass) {
          this.interfaceOutAlarmClass = res.data.interfaceOutAlarmClass;
        }
        if (res.data.interfacePushAlarmClass) {
          this.interfacePushAlarmClass = res.data.interfacePushAlarmClass;
        }
      });
    }

  }
};
</script>
<style lang="less" scoped>
@import '../../../assets/style/variable.less';
.fixed-header {
  padding: 30px 24px 15px 24px;
  border-bottom: 1px solid #e8e8e8;
}
.index-header {
  .el-card__body {
    padding: 20px 20px 8px;
    .card-content {
      h3 {
        strong {
          font-size: 30px;
        }
      }
      .chart-content {
        margin-bottom: 12px;
        position: relative;
        height: 46px;
        .chart-content__fixed {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
        }
      }
    }
    .card-footer {
      margin-top: 8px;
      padding-top: 9px;
      border-top: 1px solid #e8e8e8;
    }
    .el-icon-caret-top {
      color: #f5222d;
    }
    .el-icon-caret-bottom {
      color: #52c41a;
    }
  }
}
.index-section {
  .send-options {
    a {
      margin-left: 15px;
      text-decoration: none;
      color: rgba(0, 0, 0, .75);
      &.active {
        color: @primary;
      }
      &:hover {
        color: @primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/monitor/robotMonitor.vue